export default "__VITE_ASSET__CFBUmN1J__"